export const trimString = (str: string, trimLength: number = 8) =>
  str.slice(0, trimLength) + (str.length > trimLength ? '...' : '');
